import router from '../router/index'
import api from '../api'
const axios = require('axios')
export default {
  async login ({ dispatch }, credentials) {
    try {
      const p = { ...credentials, trainer_id: process.env.VUE_APP_TRAINER_ID }
      const response = await axios.post(api.URL_LOGIN, p)
      if (response.data.success) {
        return dispatch('getUser', response.data.userToken)
      }
      return response
    } catch (error) {
      return error.response
    }
  },
  async register ({ commit }, credentials) {
    try {
      const response = await axios.post(api.URL_REGISTER, { ...credentials, trainer_id: process.env.VUE_APP_TRAINER_ID, os_type: 'web' })
      if (response.data.success) {
        const user = response.data.user
        user.token = response.data.token
        commit('setUser', user)
        localStorage.setItem('pcc-user', JSON.stringify(user))
      }
      return response
    } catch (error) {
      return error.response
    }
  },
  async getUser ({ commit }, credentials) {
    try {
      const response = await axios.get(api.URL_GET_USER, { headers: { token: credentials } })
      if (response && response.data && response.data.success) {
        const user = response.data.user
        user.token = credentials
        commit('setUser', user)
        localStorage.setItem('pcc-user', JSON.stringify(user))
      } else {
        commit('setUser', null)
        localStorage.removeItem('pcc-user')
      }
      return response
    } catch (error) {
      commit('setUser', null)
      localStorage.removeItem('pcc-user')
      return error.response
    }
  },
  async changePass ({ commit, state }, data) {
    try {
      const url = api.URL_UPDATE_USER_PASSWORD.replace(':userID', state.user._id)
      const response = await axios.put(url, { ...data, trainer_id: process.env.VUE_APP_TRAINER_ID }, { headers: { token: state.user.token } })
      return response
    } catch (error) {
      return error.response
    }
  },
  async startSession ({ state }, data) {
    try {
      data.prices = data.prices.filter(price => price != null)
      const couponID = data.veteranCoupon || (router.history?.current?.query?.coupon) || (state.settings?.promoCode?.promoCode)
      const campaign = router.history?.current?.query?.campaign || null

      const url = api.URL_START_SESSION.concat(
        couponID ? `?coupon=${couponID}` : ''
      )

      const response = await axios.post(url, { prices: data.prices, trainer_id: process.env.VUE_APP_TRAINER_ID, route: router.history.current.path, campaign }, { headers: { token: state.user.token } })
      if (response.status === 201) {
        window.location = response.data.url
      }
      return response
    } catch (error) {
      return error.response
    }
  },
  async portalSession ({ state }, data) {
    try {
      const response = await axios.post(api.URL_OPEN_PORTAL, { trainer_id: process.env.VUE_APP_TRAINER_ID }, { headers: { token: state.user.token } })
      if (response.status === 201) {
        window.location = response.data.url
      }
      return response
    } catch (error) {
      return error.response
    }
  },
  async forgotPassword ({ commit }, email) {
    try {
      const response = await axios.post(api.URL_FORGOT_PASSWORD, { email, trainer_id: process.env.VUE_APP_TRAINER_ID })
      return response
    } catch (error) {
      return error.response
    }
  },

  async updateUser ({ commit, state }, updatedUser) {
    try {
      const url = api.URL_UPDATE_USER.replace(':userID', state.user._id)
      const response = await axios.put(url, { user: updatedUser }, { headers: { token: state.user.token } })
      if (response && response.data && response.data.success) {
        const user = response.data.user
        // user.token = credentials
        commit('setUser', user)
        localStorage.setItem('pcc-user', JSON.stringify(user))
      }
      return response
    } catch (error) {
      return error.response
    }
  }
}
